var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRocket = function SvgRocket(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 207 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5987_1234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.402 120.891L108.683 113.708C107.957 112.604 106.476 112.298 105.372 113.024C93.4874 120.882 85.3084 126.237 84.3983 126.837L86.1536 129.639L92.7756 140.21L107.672 162.885C109.287 165.343 113.102 164.244 113.172 161.301L113.357 153.492L113.484 136.261L113.894 122.631C113.912 122.014 113.74 121.406 113.402 120.891Z",
    fill: "#E31B23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1536 129.639L84.3983 126.837M84.3983 126.837L92.7756 140.21L107.672 162.885C109.287 165.343 113.102 164.244 113.172 161.301L113.357 153.492L113.484 136.261L113.894 122.631C113.912 122.014 113.74 121.406 113.402 120.891L108.683 113.708C107.957 112.604 106.476 112.298 105.372 113.024V113.024C93.4874 120.882 85.3084 126.237 84.3983 126.837Z",
    stroke: "#E31B23",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.892 81.9828L92.5659 89.1503C93.296 90.2699 92.9632 91.7405 91.8222 92.4366C79.5042 99.9162 71.0761 105.085 70.1352 105.659L68.2678 102.928L61.2229 92.6245L46.3554 69.8254C44.7534 67.3688 47.3281 64.4102 50.0777 65.548L57.5382 68.6353L73.622 75.5931L86.4699 80.8157C87.055 81.0535 87.552 81.4614 87.892 81.9828Z",
    fill: "#E31B23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2678 102.928L70.1352 105.659M70.1352 105.659L61.2229 92.6245L46.3554 69.8254C44.7534 67.3688 47.3281 64.4102 50.0777 65.548L57.5382 68.6353L73.622 75.5931L86.4699 80.8157C87.055 81.0535 87.552 81.4614 87.892 81.9828L92.5659 89.1503C93.296 90.2699 92.9632 91.7405 91.8222 92.4366V92.4366C79.5042 99.9162 71.0761 105.085 70.1352 105.659Z",
    stroke: "#E31B23",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7826 104.627L67.5929 104.246C68.6435 104.206 69.6388 104.718 70.2163 105.596L85.7251 129.192C86.3268 130.107 86.3817 131.278 85.8682 132.246L80.2889 142.76C79.0575 145.081 75.6492 144.81 74.7999 142.324L72.6092 135.91C72.2202 134.771 71.1885 133.975 69.9883 133.888L58.4648 133.048C56.5245 132.906 55.23 130.984 55.8284 129.133L59.4453 117.944C59.8313 116.75 59.4334 115.442 58.4479 114.665L52.6714 110.112C50.4813 108.386 51.6255 104.867 54.4121 104.758L57.7826 104.627Z",
    fill: "url(#paint0_radial_5987_1234)",
    stroke: "#F78E1E",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7961 105.991L66.8178 106.648C67.7079 106.745 68.5081 107.234 68.9999 107.982L83.6473 130.267C84.3622 131.355 84.2942 132.779 83.4788 133.794L83.2003 134.14C81.7414 135.956 78.8605 135.489 78.0495 133.306L76.1525 128.199C75.7882 127.218 74.9393 126.498 73.9122 126.298L69.0654 125.357C67.4376 125.041 66.3751 123.464 66.693 121.837L67.68 116.785C67.8822 115.751 67.5265 114.686 66.7433 113.981L59.956 107.869C59.8874 107.807 59.8269 107.736 59.7762 107.659C59.2743 106.896 59.8878 105.893 60.7961 105.991Z",
    fill: "url(#paint1_radial_5987_1234)",
    stroke: "#F78E1E",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.599 56.1111L151.478 65.9189C152.579 66.4128 153.301 67.4943 153.317 68.6759L153.644 92.6921",
    stroke: "#E31B23",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.34 56.236L166.691 56.3054C168.913 56.3097 170.359 58.6423 169.376 60.6339L153.844 92.0828C153.607 92.5613 153.247 92.9682 152.801 93.2613L121.475 113.852L91.9738 133.243C90.5892 134.153 88.7291 133.768 87.8191 132.383L67.0715 100.818C66.1614 99.4334 66.5461 97.5732 67.9307 96.6632L97.4316 77.2726L128.687 56.729C129.178 56.4063 129.753 56.2349 130.34 56.236Z",
    fill: "#E31B23",
    stroke: "#E31B23",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.86317,
    ry: 4.65604,
    transform: "matrix(0.496751 0.867893 -0.87068 0.49185 40.6277 102.952)",
    fill: "#63171B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.85609,
    ry: 4.66342,
    transform: "matrix(0.381705 0.924284 -0.930619 0.365989 75.355 155.786)",
    fill: "#63171B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.12297,
    ry: 2.26928,
    transform: "matrix(0.643725 0.765257 -0.783705 0.621133 43.6082 104.069)",
    fill: "#ECC94B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.1243,
    ry: 2.26878,
    transform: "matrix(0.540722 0.841201 -0.862577 0.505926 76.3252 152.805)",
    fill: "#ECC94B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.3441,
    cy: 132.88,
    rx: 8.13053,
    ry: 7.84215,
    transform: "rotate(56.6836 45.3441 132.88)",
    fill: "#FBD38D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.2973,
    cy: 141.938,
    rx: 8.13053,
    ry: 7.84215,
    transform: "rotate(56.6836 51.2973 141.938)",
    fill: "#E69999"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.9535,
    cy: 140.282,
    rx: 8.13053,
    ry: 7.84215,
    transform: "rotate(56.6836 43.9535 140.282)",
    fill: "#F78E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5987_1234",
    x: 31.908,
    y: 55.6142,
    width: 142.282,
    height: 117.127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5987_1234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5987_1234",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5987_1234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.1462 122.218) rotate(148.771) scale(18.7551 35.9055)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF921D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAC5C5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5987_1234",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.8408 119.474) rotate(149.34) scale(9.38142 22.8395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF921D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CAC5C5",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRocket);
export { ForwardRef as ReactComponent };